import React, { useEffect } from "react"
import { navigate } from "gatsby"
import styled from "styled-components"
import InfiniteScroll from "react-infinite-scroller"
import checkout from "../../../imgs/checkout.svg"
import { iconKeyToImgMapping } from "../../../utils/icons-to-imgs"
import loadingSpinner from "../../../imgs/loading-spinner.svg"
import moment from "moment"
import ReactHtmlParser from "react-html-parser"

const Container = styled.div`
  margin-bottom: 60px;
  min-height: 100%;
`

const SingleNotificationContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 20px;
  cursor: pointer;
`
const MessageContainer = styled.div`
  font-size: ${props => props.fontSize};
  font-weight: 400;
  line-height: 180%;
  text-align: justify;
  color: #0e1616;
  flex: 1;
  padding-right: ${props => props.is};
`
const MessageText = styled.div`
  margin-bottom: 4px;
`
const MessageMeta = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 180%;
  display: flex;
  align-items: center;
  color: #676767;
`
const MessageIconWrapper = styled.div`
  margin-right: 10px;
  padding-top: 10px;
  min-width: 10px;
`
const MessageIcon = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${props => (props.read ? "#A2A2A2" : "#667af4")};
`
const ActionHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 32px;
`
const Title = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;

  color: #0e1616;
`
const ActionButton = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  .button-text {
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: #667af4;
    margin-left: 5px;
  }
`

const MessageRightIconWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  align-self: center;
  margin-left: 48px;
  .right-icon-inner {
    width: 40px;
    height: 40px;
    box-shadow: 0 0 0 1px #667af4 inset;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    overflow: hidden;
  }
`

export const SingleNotification = ({
  notification,
  showRighIcon,
  isPopUp,
  isRealTime,
}) => {
  const {
    popupNotificationBody,
    fullNotificationBody,
    key,
    read,
    createdAt,
  } = notification
  return (
    <SingleNotificationContainer
      {...(isPopUp && { onClick: () => navigate("/notifications") })}
    >
      <MessageIconWrapper>{<MessageIcon read={read} />}</MessageIconWrapper>
      <MessageContainer
        fontSize={isPopUp ? "14px" : "16px"}
        className="notification-content"
      >
        <MessageText>
          {isPopUp
            ? ReactHtmlParser(popupNotificationBody)
            : ReactHtmlParser(fullNotificationBody)}
        </MessageText>
        <MessageMeta>
          {isRealTime
            ? moment(createdAt).fromNow()
            : moment(createdAt).format("MMM D, YYYY [at] hh:mm A")}
        </MessageMeta>
      </MessageContainer>
      {showRighIcon && (
        <MessageRightIconWrapper>
          <div className="right-icon-inner">
            <img
              src={iconKeyToImgMapping[key || "TEMPLATE NOTIFICATION"]}
              alt="subscriptionRenewalIcon"
            />
          </div>
        </MessageRightIconWrapper>
      )}
    </SingleNotificationContainer>
  )
}

const NotificationsLists = ({ store }) => {
  const {
    fetchNotifications,
    state: { notifications, pagination, loading },
    markAllAsReadNotification,
  } = store
  const currentPage = pagination && +pagination.current_page
  const hasMore = pagination.page_count && pagination.page_count > currentPage

  useEffect(() => {
    fetchNotifications()
  }, [fetchNotifications])

  const loader = (
    <div key="loader" style={{ textAlign: "center" }}>
      Loading ...
    </div>
  )
  if (loading && !currentPage) {
    return (
      <div style={{ textAlign: "center" }}>
        <img src={loadingSpinner} alt="spinner" />
      </div>
    )
  }

  return (
    <Container>
      <ActionHeader>
        <Title>EARLIER</Title>
        <ActionButton onClick={markAllAsReadNotification}>
          <img className="button-img" src={checkout} alt="checkoutimg" />
          <span className="button-text">Mark as Read</span>
        </ActionButton>
      </ActionHeader>
      <InfiniteScroll
        initialLoad={false}
        loadMore={() => {
          fetchNotifications(currentPage + 1)
        }}
        hasMore={hasMore}
        loader={loader}
      >
        {notifications.map((notification, idx) => (
          <SingleNotification
            notification={notification}
            isPopUp={false}
            showRighIcon={false}
            key={notification.id || idx}
          />
        ))}
      </InfiniteScroll>
    </Container>
  )
}

export default NotificationsLists
